import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const NavigateToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant' // Force an immediate hard snap
    });
  }, [pathname]);

  return null; // Takes up 0 pixels in your HTML
};

export default NavigateToTop;